import { AppInterface } from "types/types"
import Image from "next/image"
import AppActionArea from "./AppActionArea"
import DetailsArea from "./DetailsArea"
import imagePlaceholder from "utils/imagePlaceholder"
import useGlobalStore from "stores/global"

interface Props {
  app?: AppInterface
}

const MainAppCard = ({ app }: Props) => {
  const screenshotUrls = app?.screenshotUrls
  const isDark = useGlobalStore((state) => state.isDark)
  const hasScreenshot = screenshotUrls?.[0]

  return (
    <div className="main-app-card">
      <div className="card card-style">
        <div
          className="card mb-0"
          style={{
            height: "265px",
          }}
        >
          {hasScreenshot ? (
            <Image
              src={hasScreenshot}
              fill
              alt="app screenshot"
              style={{ objectFit: "cover" }}
              placeholder="blur"
              blurDataURL={imagePlaceholder(isDark)}
              priority
            />
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Image
                src={app?.artworkUrl512 || imagePlaceholder(isDark)}
                fill
                alt="app icon background"
                style={{
                  objectFit: "cover",
                  filter: "blur(40px) brightness(0.8)",
                  transform: "scale(1.2)",
                  animation: "slowRotate 60s linear infinite",
                }}
                placeholder="blur"
                blurDataURL={imagePlaceholder(isDark)}
                priority
              />
            </div>
          )}
          <AppActionArea app={app} />
          <div className="card-overlay bg-gradient-fade rounded-0"></div>
        </div>
        <DetailsArea app={app} />
      </div>
    </div>
  )
}

export default MainAppCard
